import React from "react";
import bestDate from "helpers/bestDate";
import dateString from "helpers/dateString";
import truncate from "helpers/truncate";

import Link from "next/link";

import Icon from "components/Icon";

import IconCalendar from "assets/svgs/calendar.svg";
import IconPin from "assets/svgs/pin.svg";

// move to a helper
const setBgColor = (classification) => {
  switch (classification) {
    case "Missing":
      return "bg-blue-100";
    case "Murdered":
      return "bg-red-100";
    case "Suspicious Death":
      return "bg-green-100";
    default:
      return "bg-gray-50";
  }
};

export default function FollowedCaseCards({ cases }) {
  return (
    <>
      {cases?.length > 0 ? (
        cases.map(
          ({
            classification,
            city,
            date_found: dateFound,
            date_missing: dateMissing,
            date_of_death: dateOfDeath,
            first_name: firstName,
            images: overviewImageUrls,
            last_name: lastName,
            last_updated_date: lastUpdatedDate,
            seo_name: seoName,
            summary_text: shortDescription,
            slug,
            state,
          }) => {
            const hasSeoName = seoName !== null && seoName !== "";
            const victimName = hasSeoName
              ? seoName
              : `${firstName} ${lastName}`;

            return (
              <article
                className="bg-white border card flex flex-col justify-between pb-4 rounded-md hover:elevation-1"
                key={slug}
              >
                <Link href={`/cases/${slug}`} key={`${firstName} ${lastName}`}>
                  <a className="flex flex-col flex-grow justify-between">
                    <div>
                      <div className="flex px-4 pt-4">
                        {overviewImageUrls && overviewImageUrls.length > 0 ? (
                          <figure className="card-img-container mr-4 relative">
                            <img
                              alt={`Photo of ${firstName && firstName} ${
                                lastName && lastName
                              }`}
                              loading="lazy"
                              src={overviewImageUrls[0].url}
                            />
                          </figure>
                        ) : (
                          <figure className="card-img-container mr-4 relative">
                            <img
                              alt={`Photo of ${firstName && firstName} ${
                                lastName && lastName
                              }`}
                              loading="lazy"
                                src="https://imagedelivery.net/uavUKOC7HZo0CRGpx2We4A/7bf49a2a-7489-40fc-7ffc-509b28771700/public"
                            />
                          </figure>
                        )}
                        <div className="md:pl-2">
                          <h3 className="text-xl">{victimName}</h3>
                          {classification && (
                            <span
                              className={`${setBgColor(
                                classification
                              )} inline-block mt-1 px-4 py-1 rounded-md text-sm uppercase`}
                            >
                              {classification}
                            </span>
                          )}
                          <ul className="pt-2 text-gray-500 text-sm">
                            {city && (
                              <li className="flex items-start mt-2">
                                <Icon className="flex justify-center mr-3 text-gray-400 w-5">
                                  <IconPin height="20" width="14" />
                                </Icon>{" "}
                                {city}
                                {state && <>, {state}</>}
                              </li>
                            )}
                            {(dateMissing || dateOfDeath || dateFound) && (
                              <li className="flex items-start mt-3">
                                <Icon className="flex justify-center mr-3 text-gray-400 w-5">
                                  <IconCalendar height="20" width="18" />
                                </Icon>
                                {dateString(
                                  bestDate(dateMissing, dateOfDeath, dateFound)
                                )}
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                      {shortDescription && (
                        <p className="px-4 pt-4 text-sm">
                          {truncate(shortDescription, 87, true)}
                        </p>
                      )}
                      {lastUpdatedDate && (
                        <span className="block mt-4 text-gray-500 px-4 text-xs">
                          Last updated{" "}
                          <strong className="font-semibold">
                            {dateString(lastUpdatedDate)}
                          </strong>
                        </span>
                      )}
                    </div>
                  </a>
                </Link>
              </article>
            );
          }
        )
      ) : (
        <p>There are currently no cases that match the selected filters.</p>
      )}
    </>
  );
}
